export default "__VITE_ASSET__B67Rs7kD__"